import React from "react";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Route render failed", error, errorInfo);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="m-6 rounded-2xl border border-red-100 bg-white p-6 font-Outfit shadow-sm" role="alert">
        <h1 className="text-xl font-semibold text-[#071C50]">This page could not be displayed</h1>
        <p className="mt-2 text-sm text-slate-600">
          An unexpected display error occurred. Refresh the page or return to the previous screen.
        </p>
        <div className="mt-5 flex flex-wrap gap-3">
          <button type="button" onClick={() => window.location.reload()} className="rounded-xl bg-[#1234CD] px-4 py-2 text-sm font-semibold text-white">
            Refresh page
          </button>
          <button type="button" onClick={() => window.history.back()} className="rounded-xl border border-[#1234CD] px-4 py-2 text-sm font-semibold text-[#1234CD]">
            Go back
          </button>
        </div>
      </main>
    );
  }
}

export default RouteErrorBoundary;
